import React, { useState, useEffect, useContext } from "react";
import { useRouter } from "next/router";
import AnnouncementKit from "../../data/AnnouncementKit";
import MessageItem from "./MessageItem";
import { UserContext } from "../../contexts/UserContext";

import firebaseKit from "../../data/firebase/firebaseKit";

import MessageListBrowserView from "./Views/MessageList.BrowserView";
import MessageListMobileView from "./Views/MessageList.MobileView";

import { isMobileOrTablet, isBrowserView } from "../Views/MobileClassRenderer"


export default function MessageList() {
  const [messageData, setMessageData] = useState([]);

  const [privateMessageData, setPrivateMessageData] = useState([])
  const [publicMessageData, setPublicMessageData] = useState([])
  const [isClientSide, setIsClientSide] = useState(false)

  const announcementKit = new AnnouncementKit();
  const router = useRouter();
  const { event } = router.query;
  const { me } = useContext(UserContext);

  useEffect(() => {
    setIsClientSide(true)
  }, [])

  useEffect(() => {
    firebaseKit.announcements.listenToPublicAnnouncements(
      event.toString(),
      (snapshot) => {
        if (snapshot.exists) {
          let messages = [];
          snapshot.forEach((child) => {
            messages.push(child.val());
          });
          filterMessages(messages, setPublicMessageData);
        }
      }
    );
  }, []);

  useEffect(() => {
    let uniqueIds = [];
    let messages = [].concat(privateMessageData, publicMessageData)

    messages
      .sort((a, b) => {
        return new Date(b.updated_at).valueOf() - new Date(a.updated_at).valueOf();
      })
    setMessageData(messages)
  }, [privateMessageData, publicMessageData])

  useEffect(() => {
    if (me) {
      firebaseKit.announcements.listenToPrivateAnnouncements(
        event.toString(),
        me.uuid,
        (snapshot) => {
          if (snapshot.exists) {
            let messages = [];
            snapshot.forEach((child) => {
              messages.push(child.val());
            });
            filterMessages(messages, setPrivateMessageData);
          }
        }
      );
    }
  }, [me]);

  const filterMessages = (messages = [], setter) => {
    if (event) {
      const alreadySeen = Object.entries(
        announcementKit.getMessageItemIdsFromStorage()
      ).map((item) => {
        return parseInt(item[0]);
      });
      let uniqueIds = [];
      const filteredMessages = messageData
        .concat(messages)
        // Filter messages that have expired
        .filter((message, index) => {
          let publishUntil = message?.publish_until ?? false

          if (publishUntil) {
            publishUntil = new Date(publishUntil)
          } else {
            return true
          }

          return publishUntil.getTime() > Date.now()
        })
        .filter((message, index, self) => {
          if (!uniqueIds.includes(message.id)) {
            uniqueIds.push(message.id);
            return true;
          }
          return false;
        })
        .filter((message) => !alreadySeen.includes(message.id))
        .sort((a, b) => compareMessageAge(a, b));
      setter(filteredMessages);
    }
  };
  const compareMessageAge = (a, b) => {
    return new Date(b.updated_at).valueOf() - new Date(a.updated_at).valueOf();
  };

  return (
    <>
      {isClientSide && (
        <>
          {isMobileOrTablet() && (
            <MessageListMobileView
              me={me}
              event={event}
              messageData={messageData}
            />
          )}

          {isBrowserView() && (
            <MessageListBrowserView
              me={me}
              event={event}
              messageData={messageData}
            />
          )}
        </>
      )}
    </>
  );
}
